module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"emptyList":"No resources in this section (empty list)","lmsElementNotFound":"LMS element not found (deleted ?)"},"fr":{"emptyList":"Aucune ressource dans cette section (liste vide)","lmsElementNotFound":"Elément LMS non trouvé (supprimé ?)"}}')
  delete Component.options._Ctor
}
